import React from 'react';

import { PATH } from 'src/pages/order';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { SCREENS } from 'src/constants/screens';

const QuotationRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/order')),
        title: 'order_page.title',
        screenId: SCREENS.R1006,
      },
    ],
  },
];

export default QuotationRoute;
